import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

import { CurtainHeader } from 'curtain/components/CurtainHeader';

import { clearCurtain } from 'curtain/store/curtainActions';

import { lynch } from 'shared/config/Colors';

import SVG from 'shared/components/SVG';
import { ButtonIcon } from 'shared/components/Button';
import { H3 } from 'shared/components/Typography';
import { Spacer } from 'shared/components/Layout';
import { Wrapper } from 'shared/components/Wrapper';
import { useAppDispatch } from 'shared/hooks/useAppDispatch';
import styled from 'styled-components';
import AckChangeLogTable from 'order/components/OrderLogs/components/AckChangeLogTable/AckChangeLogTable';
import { useDecision } from '@optimizely/react-sdk';
import { useIsOrderInStatus } from 'shared/hooks/useIsOrderInStatus';
import { OrderStatusEnums } from 'order/enums/orderEnums';
import { FC } from 'react';

const TabContainer = styled(Wrapper)`
  // Total page height minus header and footer heights plus bottom-border height
  height: 100%;
  overflow: auto;
`;

interface AckChangeLogTabProps {
  ackOnly?: boolean;
}

export const AckChangeLogTab: FC<AckChangeLogTabProps> = ({
  ackOnly = true,
}) => {
  const dispatch = useAppDispatch();

  const [ackChangelog] = useDecision('ack_change_log');

  const isOrderSubmitted = useIsOrderInStatus({
    status: OrderStatusEnums['Not Submitted'],
    greaterThen: true,
  });

  return (
    <Wrapper style={{ height: '100%' }}>
      <TabContainer>
        {/* Order Change Log */}
        {!ackOnly && isOrderSubmitted && (
          <Wrapper
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            {/* Heading */}
            <CurtainHeader flex middle between>
              <Wrapper flex gap={12}>
                <H3>Order Change Log</H3>
              </Wrapper>
              {/* Close Curtain Button */}
              <Wrapper flex middle>
                <ButtonIcon onClick={() => dispatch(clearCurtain())}>
                  <SVG icon={<CloseIcon />} hoverColor={lynch} />
                </ButtonIcon>
              </Wrapper>
            </CurtainHeader>
            {/* Table */}
            <Wrapper
              style={{
                flex: 1,
                overflow: 'auto',
              }}
            >
              <AckChangeLogTable ackOnly={false} />
            </Wrapper>
            {/* Footer Spacing */}
            <Spacer h="20px" />
          </Wrapper>
        )}

        {/* Ack Change Log */}
        {ackOnly && ackChangelog.enabled && (
          <Wrapper
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            {/* Heading */}
            <CurtainHeader flex middle between>
              <Wrapper flex gap={12}>
                <H3>Acknowledgement Change Log</H3>
              </Wrapper>
              {/* Close Curtain Button */}
              <Wrapper flex middle>
                <ButtonIcon onClick={() => dispatch(clearCurtain())}>
                  <SVG icon={<CloseIcon />} hoverColor={lynch} />
                </ButtonIcon>
              </Wrapper>
            </CurtainHeader>
            {/* Table */}
            <Wrapper
              style={{
                flex: 1,
                overflow: 'auto',
              }}
            >
              <AckChangeLogTable />
            </Wrapper>
            {/* Footer Spacing */}
            <Spacer h="20px" />
          </Wrapper>
        )}
      </TabContainer>
    </Wrapper>
  );
};
